import http from './http';

export async function listIssuesCount(params) {
  const { data } = await http.get('/issue-reports/count', { params });
  return data; // { total }
}

export async function listMyIssues() {
  const { data } = await http.get('/issue-reports/mine');
  return data;
}

export async function listMyIssuesCount(params) {
  const { data } = await http.get('/issue-reports/mine/count', { params });
  return data; // { total }
}

export async function createIssue(payload) {
  const { data } = await http.post('/issue-reports', payload);
  return data;
}

export async function uploadIssueAttachment(issueId, file) {
  const form = new FormData();
  form.append('file', file);
  const { data } = await http.post(`/issue-reports/${issueId}/attachments`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function listIssues(params) {
  const { data } = await http.get('/issue-reports', { params });
  return data;
}

export async function updateIssue(id, payload) {
  const { data } = await http.put(`/issue-reports/${id}`, payload);
  return data;
}

export async function deleteIssue(id) {
  const { data } = await http.delete(`/issue-reports/${id}`);
  return data;
}
